import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";
import { focusStyle } from "../utilities/Focus";

export const Wrapper = styled.div<{ height: number }>`
    min-height: ${({ height }) => height}px;
    padding-bottom: ${theme.space[3]}px;
    text-align: start;
`;

export const Item = styled.div`
    display: inline-block;
    margin: 0 ${theme.space[1]}px ${theme.space[1]}px 0;
`;

export const Button = styled.button<{ active?: boolean; color: string; asset?: string }>`
    width: 34px;
    height: 34px;
    background-color: ${({ color }) => color};
    background-image: ${({ asset }) => (asset ? `url(${asset})` : "")};
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 34px 34px;
    border-radius: 50%;

    ${focusStyle}

    ${({ active }) =>
        active &&
        css`
            border: 1px solid ${theme.colors.black};
        `};
`;
